/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M13.7914 4.21c.437 0 .7913.3474.7913.776v3.3706l4.387-4.387a.75.75 0 0 1 1.0606 1.0607l-4.4177 4.4178H19c.4371 0 .7914.3474.7914.7759 0 .4286-.3543.776-.7914.776h-6V4.986c0-.4286.3543-.776.7914-.776ZM10.2086 18.79c-.437 0-.7913-.3474-.7913-.776v-2.3706l-4.387 4.3869a.75.75 0 0 1-1.0606-1.0606l4.4177-4.4177H6c-.437 0-.7913-.3474-.7913-.776 0-.4285.3543-.776.7913-.776h5v5.014c0 .4286-.3543.776-.7914.776Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 5c0-2.7614 2.2386-5 5-5h14c2.7614 0 5 2.2386 5 5v14c0 2.7614-2.2386 5-5 5H5c-2.7614 0-5-2.2386-5-5V5Zm5-3.5h14c1.933 0 3.5 1.567 3.5 3.5v14c0 1.933-1.567 3.5-3.5 3.5H5c-1.933 0-3.5-1.567-3.5-3.5V5c0-1.933 1.567-3.5 3.5-3.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'CollapseAll'
);
